/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Meta_TitleInputs */

const en_cp_meta_title = /** @type {(inputs: Cp_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Campus — Builder & Problem Solver`)
};

const id_cp_meta_title = /** @type {(inputs: Cp_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Campus — Builder & Problem Solver`)
};

/**
* | output |
* | --- |
* | "Bystep Campus — Builder & Problem Solver" |
*
* @param {Cp_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_meta_title = /** @type {((inputs?: Cp_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_meta_title(inputs)
	return en_cp_meta_title(inputs)
});